import { ChangeEvent, useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext";
import { QueryListProvider } from "../../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../../component/solution/QueryList/QueryList";
import { Button, Card, Container, Modal } from "react-bootstrap";
import React from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import { CastType, IQuery, IWhere, IQuerySelectData, INotificationSummary } from "../../../../component/solution/Interfaces";
import { formatDateFull } from "../../../../component/solution/utils/AppUtil";
import { Info } from 'lucide-react';
import { useNavigate } from "react-router-dom";


export const WholesaleMovementOut: React.FC = () => {

    const { fetchData } = useAuth();
    const navigate = useNavigate(); 
    const queryUrlSelect: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data"}`;
    
    const [displayDashboard, setDisplayDashboard] = useState<boolean>(false);
    const [notificationSummary, setNotificationSummary] = useState<INotificationSummary[]>([]);

     const defaultQueryState: IQuerySelectData = {
      appCode: "ares",
      selectCode: "notification-summary",
      where: "category IN ('PickList', 'SalesOrder')", 
      orderBy: "",
     //pageNum: 0,
     //pageSize: 100,
    };

    const [queryState, setQueryState] = useState<IQuerySelectData>(defaultQueryState);

    const detailQueryState: IQuery = {
        tableName: "sa_m24l_pick_list_line",
        select: [
        ],
        groupBy: [],
        join: [],
        orderBy: [
            {
                fullColumnName: "item_code",
                direction: "ASC",
                cast: CastType.STRING
            }
        ],
        where: [
            {
                fullColumnName: "doc_num",
                value: "",
                operator: "EQ",
                cast: CastType.STRING
            }
        ],
        mainTableOnly: false,
        includeExtraColumns: false,
        includeControlColumns: true,
        modifiedAfter: null,
        touchedBefore: null,
        isDirty: null,
        // pageNum: 0,
        // pageSize: 20,
        frontEndOnly: null
    }


    useEffect(() => {
        fetchSummary();
    }, [])

    const fetchSummary = () => {
        fetchData(queryUrlSelect, {method:"POST", body: JSON.stringify(queryState)}, processData );
    }

    const processData = (result: any) => {

      const data: INotificationSummary[] = [];

      for (const key in result.data) {
         const item = result.data[key];
         data.push({ ...item.data});
      } 

      setNotificationSummary(data);
    }
 

    const generateDetailTables = (detail: any[]) => {
        const detailTable: React.ReactElement[] = [];
        let totalQuantityOrdered = 0;
        let totalQuantitySent = 0;

        // Sort by line_num ascending before rendering
        const sortedDetail = [...detail].sort((a, b) => {
            const aLine = a.data?.line_num ?? 0;
            const bLine = b.data?.line_num ?? 0;
            return aLine - bLine;
        });

        sortedDetail.forEach((item, idx) => {
            const data = item.data;
            totalQuantityOrdered += data?.qty_ordered ?? 0;
            totalQuantitySent += data?.qty_sent ?? 0;

            detailTable.push(
            <tr key={idx}>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.line_num}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.item_code}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.qty_ordered}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.qty_sent}</td>
            </tr>
            );
        });

        const summaryTable = (
            <table className="table w-auto" style={{ border: '1px solid #adb5bd' }}>
            <tbody>
                <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Unique Item Total</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{detail.length}</td>
                </tr>
                    <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Total Qty Ordered</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{totalQuantityOrdered}</td>
                </tr>
                <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Total Qty Sent</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{totalQuantitySent}</td>
                </tr>
            </tbody>
        </table>
        );

        return { summaryTable, detailTable };
    };

    /*
     Outbound - Wholesale

        [Error]
        PickList

        [Status]
        TO_SEND - Document ready to be sent to M24L.
        SENT - Doument has has been sent to M24L for processing.
        SUCCESS - document successfully received at M24L for processing.
        ERROR - There was a problem integrating the document at M24L.
        PICKING - M24L have started picking the stock.
        DISPATCHED - Stock dispatched from M24L.
        CLOSED - Document processing complete.

    */


    const thStyle = { backgroundColor: '#293042', border: '1px solid #deebed', fontWeight: 600, color:'white', padding: '12px 8px', fontSize: '0.75rem'};
    const cellStyle: React.CSSProperties = { border: '1px solid #deebed', whiteSpace: 'nowrap', padding: '5px 8px', fontSize: '0.75rem', verticalAlign: 'middle' };

    const salesOrderData = notificationSummary.filter(d => d.category === 'SalesOrder');
    const pickListData = notificationSummary.filter(d => d.category === 'PickList');
    
    const TableComponent = (items: INotificationSummary[]) => {
        return (
            <div className="notification-summary-container">
            <div className="inner-container">
                <table className="notification-summary-table">
                    <thead>
                        <tr>
                            <th style={{ ...thStyle, width: '150px' }}>Category</th>
                            <th style={{ ...thStyle, width: '200px' }}>Description</th>
                            <th style={{ ...thStyle, width: '100px' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                         {items.length === 0 ? (
                            <tr>
                                <td colSpan={3} style={{ ...cellStyle, textAlign: 'center' , color: '#888' }}>
                                    No Data Available For Today
                                </td>
                            </tr>
                        ) : (
                            items.map((item, i) => (
                                <tr key={i}>
                                    <td style={{ ...cellStyle, width: '150px' }}>{item.category}</td>
                                    <td style={{ ...cellStyle, width: '200px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                        title={item.description}
                                    >
                                        {item.description}
                                    </td>
                                    <td style={{ ...cellStyle, width: '100px', position: 'relative' }}>
                                        {item.total}
                                        <span
                                            title="More info"
                                            style={{ position: 'absolute', top: 4, right: 4, color: '#888', cursor: 'pointer' }}
                                            onClick={() => {
                                                navigate('/m24l/notifications-new', {
                                                    state: {
                                                        category: item.category,
                                                        description: item.description,
                                                        last_encountered: item.last_encountered
                                                    }
                                                });
                                            }}
                                        >
                                            <Info size={14} />
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
         </div>
        );
    };

    return (
        <React.Fragment>
            <Container fluid className="p-0">
            <Card>
              <div>
                <div className="notification-summary-layout"> 
                    <button
                        className="btn btn-light notification-summary-btn"
                        title={displayDashboard ? "Close Display Dashboard" : "Open Display Dashboard"}
                        onClick={() => setDisplayDashboard(!displayDashboard)}
                     >
                      {displayDashboard ? ( <ArrowUp size={18} />) : (<ArrowDown size={18} />)}
                    </button>
                </div>

                {displayDashboard && (
                <div className="notification-summary-outer-container">
                    <div className="outer-inner-container">
                            {TableComponent(salesOrderData)}
                            {TableComponent(pickListData)}
                        </div>
                    </div>
                    )}
                </div>
            </Card>
            <QueryListProvider>
                    <QueryList
                        listTitle={"Outbound Wholesale"}
                        recordTitle={"Outbound Wholesale"}
                        tableName={"sa_m24l_pick_list"}
                        editTableName={"sa_m24l_pick_list"}
                        hasIntegrationStatusLegend={true}
                        integrationstatusLegend={[
                            { status: 'ERROR', color: '#bf3636', description: 'There was a problem integrating the document at M24L.'},
                            { status: 'TO_SEND', color: '#d4a53f', description: 'Document ready to be sent to M24L.'},
                            { status: 'PICKING', color: '#d4a53f', description: 'M24L have started picking the stock.'},
                            { status: 'DISPATCHED', color: '#d4a53f', description: 'Stock dispatched from M24L.'},
                            { status: 'SENT', color: '#d4a53f', description: 'Doument has been sent to M24L for processing.'},
                            { status: 'SUCCESS', color: '#d4a53f', description: 'Document successfully received at M24L for processing.'},
                            { status: 'CLOSED', color: '#3ec76b', description: 'Document processing complete.'}
                        ]}
                        errorCategoryName={'PickList'}
                        modal={
                            {
                              modalTitle: "Doc Num:",
                              modalSubtitle: "Outbound Wholesale:",  //Shipment Confirmation
                              modalProptBy: "doc_num",
                              tableName: "sa_m24l_pick_list",
                              tableLineQuery: "sa_m24l_pick_list_line",
                              modalAction: 'viewing',
                              modalHasViewing: true,
                              queryData: detailQueryState,
                              processData: (result: any) => {

                                const detail: any[] = result.data;
                                const { summaryTable, detailTable } = generateDetailTables(detail);
                             
                                 return (
                                    <div className="d-flex flex-column gap-3" >
                                        <div style={{background:"#f2f5f3"}} className="p-2">
                                            <h6 className="text-secondary fw-bolder">
                                               Summary
                                            </h6>
                                            <div className="mb-3">{summaryTable}</div>
                                        </div>

                                        <div style={{background:"#f2f5f3"}} className="p-2">
                                            <h6 className="text-secondary fw-bolder">
                                                Line Details
                                            </h6>
                                            <table className="table" style={{ border: '1px solid #adb5bd' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Line No.</th>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Item Code</th>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Qty Ordered</th>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Qty Sent</th>
                                                    </tr>
                                                </thead>
                                                <tbody>{detailTable}</tbody>
                                            </table>
                                        </div>
                                    </div>
                                 );
                              }
                            }
                        }
                        editHasCompoundKey={false}
                        join={[{
                            relationship: "notifications",
                            joinType: "LEFT"
                        }]} 
                        select={[
                            {
                                fullColumnName: "doc_num",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "order_doc_num",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "division",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "card_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "card_name",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "num_at_card",
                                aggregate: ""
                            },    
                            {
                                fullColumnName: "original_warehouse",
                                aggregate: ""
                            },  
                            {
                                fullColumnName: "warehouse_code",
                                aggregate: ""
                            },             
                            {
                                fullColumnName: "vas_code",
                                aggregate: ""
                            },     
                            {
                                fullColumnName: "integration_status",
                                aggregate: ""
                            },   
                            {
                                fullColumnName: "total_qty",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "comments",
                                aggregate: ""
                            },                         
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "notifications.reference",
                                aggregate: "COUNT"
                            },
                        ]}
                        where={[]} 
                        orderBy={[    
                            {
                                fullColumnName: "doc_num",
                                direction: "DESC",
                                cast: CastType.INTEGER
                            }
                         ]} 
                        groupBy={[
                            "doc_num",
                            "order_doc_num",
                            "division",
                            "card_code",
                            "card_name", 
                            "num_at_card",
                            "original_warehouse",
                            "warehouse_code",
                            "vas_code",     
                            "integration_status",
                            "total_qty",
                            "comments",                       
                            "created",
                            "updated",
                        ]}                   
                    />
                </QueryListProvider>
            </Container>
      </React.Fragment>
    )
}

